export function isSafari(userAgent?: string) {
  return /^((?!chrome|android).)*safari/i.test(
    userAgent || navigator.userAgent
  );
}
